"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselSlideMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PhotoCarouselSlideMixin */
/** @method */
var PhotoCarouselSlideMixin = function PhotoCarouselSlideMixin(props) {
  var shouldAnimateTranslations = props.shouldAnimateTranslations,
    slidePosition = props.slidePosition;
  return (0, _styledToken.default)({
    animationDuration: 'PhotoCarousel.animations.defaultDuration',
    animationFunction: 'PhotoCarousel.animations.defaultTimingFunction',
    translateX: "PhotoCarousel.slide.horizontalTranslations." + slidePosition,
    zIndex: "PhotoCarousel.slide.zIndices." + slidePosition
  }, function (_ref) {
    var animationDuration = _ref.animationDuration,
      animationFunction = _ref.animationFunction,
      translateX = _ref.translateX,
      zIndex = _ref.zIndex;
    return (0, _styledComponents.css)(["transition:transform ", "s ", ";transform:translateX(", "%);z-index:", ";position:absolute;left:0;top:0;right:0;bottom:0;@media (prefers-reduced-motion:reduce){&{transition:none;}}"], shouldAnimateTranslations ? animationDuration : '0', animationFunction, translateX, zIndex);
  })(props);
};
exports.PhotoCarouselSlideMixin = PhotoCarouselSlideMixin;